import * as React from "react";
const SvgSpeed = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "m20.39 8.56-1.24 1.86a8 8 0 0 1-.22 7.58H5.07A8 8 0 0 1 15.58 6.85l1.86-1.24A10 10 0 0 0 4 20h16a10 10 0 0 0 .38-11.44h.01Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.59 15.41a1.998 1.998 0 0 0 2.83 0l5.66-8.49-8.49 5.66a1.999 1.999 0 0 0 0 2.83Z",
  fill: "currentColor"
}));
export default SvgSpeed;